const usersListReducer = ( state = {
	findUsers: null,
    usersListFilteredStatus: null,
    usersListFilteredLicense: null,
	usersListFilteredRole: null,
	getAdministrators: null
}, action ) => {
	switch (action.type){
		case "FIND_USERS":
			state = {
				...state,
				findUsers: action.payload
			};
			break;
        case "USERS_LIST_FILTERED_STATUS":
            state = {
                ...state,
                usersListFilteredStatus: action.payload
            };
            break;
        case "USERS_LIST_FILTERED_LICENSE":
            state = {
                ...state,
                usersListFilteredLicense: action.payload
            };
            break;
		case "USERS_LIST_FILTERED_ROLE":
			state = {
				...state,
				usersListFilteredRole: action.payload
			};
			break;
		case "GET_ADMINISTRATORS":
			state = {
				...state,
				getAdministrators: action.payload
			};
			break;
		default :
			break;
	}
	return state;
};

export default usersListReducer;
